import { defineStore } from 'pinia';

type Nullable<T> = T | null;



export const usePaymentPortalConfigStore = defineStore('paymentPortalConfig', {
    state: () => ({
        //store reactive data properties
        paymentPortalConfiguration: null as Nullable<Server.IApplicationConfig>
    }),
    getters: {},
    actions: {},
    persist: true
})
